export const HARDWARE_TITLE_MAX = 200;
export const HARDWARE_DESCRIPTION_MAX = 2000;

export const EDU_BUDGET_TITLE_MAX = 200;
export const EDU_BUDGET_DESCRIPTION_MAX = 2000;
export const EDU_BUDGET_LINK_MAX = 2048;

export const VACATION_DESCRIPTION_MAX = 500;
export const OOO_DESCRIPTION_MAX = 500;

export const DENY_NOTE_MAX = 160;
export const BUDGET_COST_NAME_MAX = 60;
export const NOTES_MAX = 160;

// Keep these in sync with the size/content-type checks in storage.rules (match /invoices/{requestId}/{fileName})
export const INVOICE_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const ALLOWED_INVOICE_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/webp',
];

// Blocks only HTML/XSS injection characters: < > &
export const TEXT_FIELD_REGEX = /^[^<>&]*$/u;
export const TEXT_FIELD_MESSAGE = 'Characters < > & are not allowed';
